
import React from "react";
import { ArrowUp } from "lucide-react";
import { Button } from "@/components/ui/button";

export const ScrollToTopButton = () => {
  return (
    <Button
      id="scroll-to-top"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-8 right-8 z-50 p-3 bg-gradient-to-r from-purple-600 via-purple-500 to-sky-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 opacity-0 translate-y-10 pointer-events-none group"
      size="icon"
    >
      <ArrowUp className="h-4 w-4 transform group-hover:scale-110 transition-transform duration-300" />
    </Button>
  );
};
